import React, { Component } from 'react';
import './index.css';
import Recommendations from './recommendations';
import LatestThreads from './latest';

import { store } from '../../redux/store';
import * as ChatActions from '../../redux/actions/chat';

class Home extends Component {

	constructor(props) {
		super(props);
	}

	componentDidMount() {
		store.dispatch(ChatActions.setThemeImage({
			theme_image: null
		}));
	}

	render() {
		return (
			<div className='homepage'>
				<LatestThreads />
				{/*
					* Amazon Ads component. Move this to Yoshi.
					* <Ads adId="d4879ce7-3d76-4f79-99fc-7543372bfa4a" />
				  */}
				<Recommendations />
			</div>
		);
	}
}

export default Home;